import DataMesControlled from "../DataMesControlled";
import SelectStatusControlled from "../SelectStatusSemLabel";
import BarraBuscaComTodasUnidades from "../BarraBuscaComTodasUnidades";
import SelectModeloItemFormularioControlled from "../SelectModeloItemFormulario";
import SelectBlocoItemFormularioControlled from "../SelectBlocoItemFormularioControlled";

function FiltrosPendencias({ filtros, updateFiltro }) {

    console.log('### Iniciando FiltrosPendencias ###')

    return (
        <div className='d-flex flex-column gap-1 div-com-borda p-3'>


            {/* LINHA 1 */}

            <div className="row align-items-center">

                <div className="d-flex col-6">
                    <div className="col">
                        <label htmlFor="status-pendencia">Status</label>
                        <SelectStatusControlled
                            id="status-pendencia"
                            value={filtros.statusId}
                            onChange={(v) => updateFiltro("statusId", v)}
                        />
                    </div>
                </div>

            </div>

            {/* LINHA 2 */}

            <div className="row align-items-center">
                <div className="col">
                    <label htmlFor="bloco-item">Bloco</label>
                    <SelectBlocoItemFormularioControlled
                        id="bloco-item"
                        value={filtros.blocoItemId}
                        onChange={(v) => updateFiltro("blocoItemId", v)}
                    />
                </div>

                <div className="col">
                    <label htmlFor="modelo-item-formulario">Pergunta</label>
                    {filtros.blocoItemId ? (
                        <>
                            <SelectModeloItemFormularioControlled
                                id="modelo-item-formulario"
                                value={filtros.modeloItemId}
                                blocoItemId={filtros.blocoItemId}
                                onChange={(v) => updateFiltro("modeloItemId", v)}
                            />
                        </>
                    ) : (
                        <>
                            <p className="m-0">** Selecione um <strong>Bloco</strong> de perguntas para listar o filtro por perguntas</p>
                        </>
                    )
                    }
                </div>

            </div>

            {/* LINHA 3 */}

            <div className="d-flex mt-2 mb-2 align-items-center">

                <div className="d-flex gap-3 col-6">
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="desconsiderar-filtro-data">
                            Não filtrar por data
                        </label>
                        <input
                            className="form-check-input"
                            type="radio"
                            id="desconsiderar-filtro-data"
                            onChange={() => updateFiltro("filtroPeriodo", null)}
                            checked={filtros.filtroPeriodo === null}
                        />
                    </div>

                    <div className="form-check">
                        <label className="form-check-label" htmlFor="filtro-mes">
                            Mês
                        </label>
                        <input
                            className="form-check-input"
                            type="radio"
                            id="filtro-mes"
                            onChange={() => updateFiltro("filtroPeriodo", "mes")}
                            checked={filtros.filtroPeriodo === 'mes'}
                        />
                    </div>

                    <div className="form-check">
                        <label className="form-check-label" htmlFor="filtro-periodo">
                            Período
                        </label>
                        <input
                            className="form-check-input"
                            type="radio"
                            id="filtro-periodo"
                            onChange={() => updateFiltro("filtroPeriodo", "periodo")}
                            checked={filtros.filtroPeriodo === 'periodo'}
                        />
                    </div>
                </div>

                <div className="container-das-datas col-6">

                    {
                        filtros.filtroPeriodo === null ? (

                            <div className=''>
                            </div>

                        ) : filtros.filtroPeriodo === 'mes' ? (

                            <div className="d-flex col-5 gap-2 align-items-center">
                                <label className='text-nowrap' htmlFor='filtro-mes'>Mês</label>
                                <DataMesControlled id='filtro-mes'
                                    mes={filtros.mesCompetencia}
                                    onChange={(v) => updateFiltro("mesCompetencia", v)}
                                    getUltimoDia={false}
                                />
                            </div>

                        ) : (

                            <div className="d-flex gap-3  align-items-center">
                                <label className='text-nowrap' htmlFor='filtro-mes-inicio'>Mês Início</label>
                                <DataMesControlled id='filtro-mes-inicio'
                                    mes={filtros.mesInicio || ""}
                                    onChange={(v) => updateFiltro("dataInicio", v)}
                                    getUltimoDia={false}
                                />
                                <label className='text-nowrap' htmlFor='filtro-mes-fim'>Mês Fim</label>
                                <DataMesControlled id='filtro-mes-fim'
                                    mes={filtros.mesFim || ""}
                                    onChange={(v) => updateFiltro("dataFim", v)}
                                    getUltimoDia={true}
                                />
                            </div>
                        )
                    }

                </div>

            </div>

            {/* LINHA 4 */}

            <div className="container-principal d-flex col-12">

                <div className="coluna-a col-6 d-flex">

                    <div className="col-8">

                        <div className="form-check">
                            <label className="form-check-label" htmlFor="nao-considera-vencidas">
                                Não considerar vencimento
                            </label>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="vencimento-options"
                                id="nao-considera-vencidas"
                                onChange={() => updateFiltro("modoVencimento", "none")}
                                checked={filtros.modoVencimento === "none"}
                            />
                        </div>

                        <div className="form-check">
                            <label className="form-check-label" htmlFor="considera-vencidas">
                                Vencidas
                            </label>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="vencimento-options"
                                id="considera-vencidas"
                                onChange={() => updateFiltro("modoVencimento", "vencidas")}
                                checked={filtros.modoVencimento === "vencidas"}
                            />
                        </div>

                        <div className="form-check">
                            <label className="form-check-label" htmlFor="considera-a-vencer">
                                A vencer
                            </label>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="vencimento-options"
                                id="considera-a-vencer"
                                onChange={() => updateFiltro("modoVencimento", "aVencer")}
                                checked={filtros.modoVencimento === "aVencer"}
                            />

                        </div>

                    </div>

                    {filtros.modoVencimento === "aVencer" &&
                        (
                            <div className="d-flex gap-1 align-items-center">
                                <label>Dias a vencer</label>
                                <select
                                    className="form-control-sm h-25"
                                    id="pendencias-a-vencer"
                                    value={filtros.diasAVencer || ""}
                                    onChange={(v) => updateFiltro("diasAVencer", v.target.value === "" ? null : v.target.value)}

                                >
                                    <option value="">Selecione...</option>
                                    <option value="30">30 dias</option>
                                    <option value="60">60 dias</option>
                                    <option value="90">90 dias</option>
                                    <option value="120">120 dias</option>
                                </select>
                            </div>
                        )
                    }

                </div>

                <div className="coluna-b col-6">

                </div>

            </div>

            {/* LINHA 5 */}

            <div className='row'>
                <BarraBuscaComTodasUnidades
                    setEstabelecimento={(estabelecimento) => updateFiltro("estabelecimentoId", estabelecimento)}
                    somenteAtivos={false}
                    enviaRelatorioAcompanhamento={false}
                />
            </div>

        </div>
    );
}

export default FiltrosPendencias;
